import { useState } from 'react';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { DownloadIcon } from 'foundations-assets/icons/components/DownloadIcon';
import I18n from 'I18n';
import { downloadAttachment } from '../utils/downloadAttachment';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MessageImage = ({
  image
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const isUsingPillBorderRadius = useIsPillBorderRadius();
  const handleDownload = () => {
    void downloadAttachment(image.attachment.fileMetadata);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "center",
    gap: "400",
    maxInlineSize: "100%",
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    children: [/*#__PURE__*/_jsx(Image, {
      src: image.attachment.fileMetadata.url,
      maxInlineSize: "80%",
      maxBlockSize: "800px",
      objectFit: "contain",
      borderRadius: isUsingPillBorderRadius ? '0' : '400'
    }, image.fileId), /*#__PURE__*/_jsx(Flex, {
      minInlineSize: "48px",
      alignItems: "center",
      justifyContent: "center",
      children: isHovered && /*#__PURE__*/_jsx(IconButton, {
        onClick: handleDownload,
        tooltip: I18n.text('customer-portal-app.ticketThread.messageContent.attachment.download'),
        use: "form",
        shape: "circle",
        children: /*#__PURE__*/_jsx(DownloadIcon, {
          size: "300",
          color: "icon-core-subtle"
        })
      })
    })]
  });
};